import { sensorsApi, timeseriesApi } from "./client"
import type {
  EnvironmentTypesResponse,
  EnvironmentLocation,
  PaginatedResponse,
  WeatherResult,
} from "@/types/api"

export async function fetchEnvironmentTypes(): Promise<EnvironmentTypesResponse> {
  return sensorsApi
    .get("api/environments/type-detail/", {
      searchParams: { page_size: 5000 },
    })
    .json<EnvironmentTypesResponse>()
}

export async function fetchEnvironmentLocation(
  lon: number,
  lat: number,
  environmentType: string,
): Promise<EnvironmentLocation[]> {
  const response = await sensorsApi
    .get("api/environments/location/", {
      searchParams: {
        location: `POINT (${lon} ${lat})`,
        environment_type: environmentType,
      },
    })
    .json<PaginatedResponse<EnvironmentLocation>>()
  return response.results
}

export interface FetchEnvironmentReadingsParams {
  environment: {
    environment_id: string
    environment_type: string
    environment_channels: string[]
  }
  start_date?: string
  end_date?: string
  downsampling_method?: string
  hour_of_day?: number
  standardise?: boolean
}

// The backend fans channels out concurrently and loads one value per day, so
// a combined per-type request returns comfortably — but keep a generous
// timeout above the default for larger date ranges.
const ENVIRONMENT_READINGS_TIMEOUT_MS = 60_000

export async function fetchEnvironmentReadings(
  params: FetchEnvironmentReadingsParams,
): Promise<{ results: WeatherResult[] }> {
  return timeseriesApi
    .post("api/environment/readings/", {
      json: params,
      timeout: ENVIRONMENT_READINGS_TIMEOUT_MS,
    })
    .json<{ results: WeatherResult[] }>()
}
